export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.7.1',
    name: 'fpar',
    versionDate: '2026-03-24T21:11:55.604Z',
};
export default versions;
